import { useState } from 'react'
import useDebouncedEffect from '~/hooks/useDebouncedEffect'

export function useDebouncedValue<T = any>(value: T, delay?: number, deepEquals = false) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useDebouncedEffect(
    () => {
      // Update debounced value after delay
      setDebouncedValue(value)
    },
    { delay, deepEquals },
    [value]
  )

  return debouncedValue
}
